import { Component, OnInit } from "@angular/core";
import { HttpService } from "../../http.service";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { Domain as WebsideDomain } from "../../../../../lib/Domain/Webside";
@Component({
  selector: "app-smart-panel",
  templateUrl: "./smart-panel.component.html",
  styleUrls: ["./smart-panel.component.css"]
})
export class SmartPanelComponent implements OnInit {

  public productlists: WebsideDomain.IProduct[] = [];
  public selectedProduct: WebsideDomain.IProduct;
  public selectedtimestamp: Date = new Date();

  filterdate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate(),
  };
  model = {
    left: true,
    middle: false,
    right: false
  };

  constructor(private httpService: HttpService, private modalService: NgbModal) { }

  async ngOnInit() {
    this.productlists = await this.httpService.smartPanelService.List();
    if (this.productlists.length > 0) {
      this.onSelected(this.productlists[0]);
    }
  }
  async onUpdate() {
    this.productlists = await this.httpService.smartPanelService.List();
    this.model = {
      left: this.model.left,
      middle: this.model.middle,
      right: this.model.right,
    };
  }
  onSelected(e: WebsideDomain.IProduct) {
    this.selectedProduct = e;
  }
  OnFind(f: any) {
    this.selectedtimestamp = new Date(this.filterdate.year, this.filterdate.month - 1, this.filterdate.day);
  }


}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/Page/smart-panel/smart-panel.component.ts